







import Vue from 'vue';

export default Vue.extend({
  name: 'InfoTooltip',
  props: {
    tooltipText: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  }
});
